"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteMailbox = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 234 150",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.41 0h65.18A4.41 4.41 0 0 1 80 4.41v35.18A4.41 4.41 0 0 1 75.59 44H33l-15 8-1-8h-6.59A4.41 4.41 0 0 1 6 39.59V4.41A4.41 4.41 0 0 1 10.41 0z",
      id: "a"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0 0l92.7 58.204c5.613 3.524 7.306 10.93 3.782 16.543a12 12 0 0 1-10.163 5.62L7 80.365a7 7 0 0 1-7-7V0z",
      id: "b"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M129.568 24.731c-14.296-.497-27.913-5.136-40.914-10.21C75.652 9.445 62.77 3.82 48.818 1.131 39.843-.597 29.578-.84 22.348 3.994c-6.96 4.646-9.209 12.689-10.416 20.135-.91 5.615-1.445 11.51 1.046 16.761 1.73 3.646 4.803 6.709 6.929 10.2 7.39 12.149 2.17 27.13-5.846 38.993-3.75 5.564-8.117 10.873-11.016 16.795-2.9 5.923-4.241 12.71-1.705 18.753 2.516 5.99 8.508 10.488 14.998 13.652 13.185 6.428 14.485 10.76 29.713 10.715 34.188-.1 81.346-.1 115.019 0 12.457.037 24.966-1.844 37.21-3.778 6.796-1.075 13.814-2.778 18.748-6.895 6.266-5.227 7.819-14.07 3.62-20.619-7.036-10.984-26.509-13.71-31.43-25.504-2.71-6.49.072-13.72 4.01-19.749 8.446-12.911 22.604-24.24 23.35-39 .513-10.138-6.293-20.29-16.816-25.087-11.032-5.033-26.327-4.394-34.465 3.927-8.38 8.583-23.106 11.88-35.729 11.438z",
      fillOpacity: ".136",
      fill: "#1657E2",
      className: "fill-primary",
      fillRule: "nonzero"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(154 13)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fill: "#88A9F0",
        className: "fill-primary-opa50",
        xlinkHref: "#a"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fillOpacity: ".499",
        fill: "#FFF",
        xlinkHref: "#a"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M158.41 13h65.18a4.41 4.41 0 0 1 4.41 4.41v35.18a4.41 4.41 0 0 1-4.41 4.41H179l-7 8-7-8h-6.59a4.41 4.41 0 0 1-4.41-4.41V17.41a4.41 4.41 0 0 1 4.41-4.41z",
      fill: "#FFF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C3D4F7",
      className: "fill-primary20",
      d: "M166 25h49v6h-49zM166 38h37v6h-37z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M141 69.633L77 20 13 69.633v73.365a7 7 0 0 0 7 7h114a7 7 0 0 0 7-7V69.633z",
        fill: "#1657E2",
        className: "fill-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M113 29H34v104h79z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M118 41H39v104h79z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D4F7",
        className: "fill-primary20",
        d: "M100 64H47v6.003h53zM80 49H47v6.003h33zM100 79H47v6.003h53z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "matrix(-1 0 0 1 141 69.633)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
          id: "c",
          fill: "#fff",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
            xlinkHref: "#b"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          fill: "#C3D4F7",
          className: "fill-primary20",
          xlinkHref: "#b"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M128 0v73.365a7 7 0 0 1-7 7H0L128 0z",
          fill: "#FFF",
          mask: "url(#c)"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M13 69.633v73.365a7 7 0 0 0 7 7h113.46L13 69.633z",
        fill: "#FFF"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M153 66h6a2 2 0 0 1 2 2v66h-10V68a2 2 0 0 1 2-2z",
        fill: "#88A9F0",
        className: "fill-primary-opa50"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M155.987 66H159a2 2 0 0 1 2 2v66h-4.992l-.021-68z",
        fill: "#1657E2",
        className: "fill-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M151 134h10l-5 9z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#1657E2",
        className: "fill-primary",
        d: "M157.66 140.01L156 143l-1.666-2.998z"
      })]
    })]
  })]
});
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteMailbox')(IllustrationMySiteMailbox);